import { useEffect } from "react";
import { useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectSelectedPnsIds, setSelectedPnsIdsInRedux } from "../DesignTab/routing/pnsSelectionSlice";

export const useHydratePnsFromUrl = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const currentSelected = useAppSelector(selectSelectedPnsIds);
  const hasHydratedRef = useRef(false);

  useEffect(() => {
    if (hasHydratedRef.current) return;
    hasHydratedRef.current = true;

    const fromRepeatedParams = searchParams.getAll("pns").map((x) => x.trim()).filter(Boolean);
    const rawCommaSeparated = searchParams.get("pns");
    const hasPnsInUrl = fromRepeatedParams.length > 0 || rawCommaSeparated != null;
    if (!hasPnsInUrl) return;

    const parsed =
      fromRepeatedParams.length > 1
        ? fromRepeatedParams
        : (rawCommaSeparated ?? "")
            .split(",")
            .map((x) => x.trim())
            .filter(Boolean);

    const fromUrl = Array.from(
      new Set(
        parsed
      )
    );

    if (
      fromUrl.length !== currentSelected.length ||
      fromUrl.some((id, idx) => id !== currentSelected[idx])
    ) {
      dispatch(setSelectedPnsIdsInRedux(fromUrl));
    }
  }, [currentSelected, dispatch, searchParams]);
};
